import { useState, useEffect } from 'react';
import { useLandbotContext } from 'context/landbot.context';
import { NAMES } from 'game/objects/character';
import EVENTS from 'constants/EVENTS';
import { getAssetsUrl } from 'utilities';

const AVATARS = {
  'bat': getAssetsUrl('characters/bat.png'),
  [NAMES.MEXICAN_WOMAN]: '',
  [NAMES.COWBOY]: '',
  [NAMES.OLD_WOMAN]: '',
  [NAMES.SCREAM]: '',
  [NAMES.MONSTER]: '',
}

export default function useLandbotSpeaker() {
  const { landbot } = useLandbotContext();
  const [speaker, setSpeaker] = useState(AVATARS['bat']);

  useEffect(() => {
    const _setSpeaker = (data) => {
      setSpeaker(data?.avatar || data);
    };

    landbot.events.on(EVENTS.SET_SPEAKER, _setSpeaker);
    return () => landbot.events.off(EVENTS.SET_SPEAKER, _setSpeaker);
  }, [landbot]);

  return speaker;
}